import React from 'react';

export const Privacy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <div className="prose prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Data Collection</h2>
          <p className="mb-4">
            Peptide Now is committed to protecting your privacy. Our calculator:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Operates entirely in your browser</li>
            <li>Does not collect or transmit personal information</li>
            <li>Stores calculation history locally on your device only</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Google Analytics</h2>
          <p className="mb-4">
            We use Google Analytics to understand web traffic and improve our website. This includes:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Tracking anonymous usage data (e.g., page views, session duration)</li>
            <li>Not collecting personal or identifiable information</li>
          </ul>
          <p className="mb-4">
            Google Analytics uses cookies to gather this information. For more details, you can review 
            Google's Privacy Policy:{' '}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              https://policies.google.com/privacy
            </a>
          </p>
          <p className="mb-4">
            You can opt out of Google Analytics tracking by disabling cookies in your browser settings or 
            using the Google Analytics opt-out browser add-on:{' '}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              https://tools.google.com/dlpage/gaoptout
            </a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Local Storage</h2>
          <p className="mb-4">
            We use local storage to save your calculation history for your convenience. This data:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Remains on your device only</li>
            <li>Can be cleared at any time using the "Clear History" function</li>
            <li>Is not accessible to us or any third parties</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Contact Information</h2>
          <p>
            If you have any questions about our privacy practices or need to contact us for any reason, 
            please email us at:{' '}
            <a 
              href="mailto:peptidenow@gmail.com"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              peptidenow@gmail.com
            </a>
          </p>
          <p className="mt-4">
            We are committed to maintaining the trust you place in us by using our calculator and will 
            respond to your inquiries in a timely manner.
          </p>
        </section>
      </div>
    </div>
  );
};
